import clsx from "clsx";
import Link from "next/link";
import { BlankProduct, type SimpleBlankProduct } from "shared-components";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import type { Product } from "@/api/product/models";
import { CarouselNavigationButtons } from "@/components/CarouselNavigationButtons";

import "./styles.css";

import type { JSX } from "react";

export interface Props {
  id: string;
  title: string;
  products: Product[];
  loading?: boolean;
  className?: string;
}

const MAX_PRODUCTS = 5;

const productDto = (data: Product): SimpleBlankProduct => ({
  id: data.id,
  colors: data.colors,
  price: +data.price,
  imageSrc: data.imageUrls[1] || data.imageUrls[0],
  name: data.name,
  printName: data.printName,
});

export const ProductGroup = ({ id, title, products, loading, className }: Props): JSX.Element | null => {
  if (!loading && !products.length) {
    return null;
  }

  return (
    <div className={clsx("home-product-group flex w-full justify-center px-page-x-margin", className)}>
      <div className="relative w-full max-w-page-max-width">
        <h2 className="text-4xl mb-6">{title}</h2>

        {loading && (
          <div className="flex gap-3 overflow-hidden">
            {Array.from({ length: MAX_PRODUCTS }, (_, index) => (
              <BlankProduct key={index} loading item={{} as SimpleBlankProduct} />
            ))}
          </div>
        )}

        {!!products.length && (
          <Swiper
            slidesPerView="auto"
            modules={[Navigation]}
            navigation={{
              disabledClass: "disabled",
              prevEl: `#${id}-products-button-prev`,
              nextEl: `#${id}-products-button-next`,
            }}
            freeMode
          >
            {products.map((product) => (
              <SwiperSlide key={product.id} className="ml-2 first:ml-0">
                <Link href={`/${product.id}`}>
                  <BlankProduct
                    key={product.id}
                    item={productDto(product)}
                    className="max-sm:max-w-[9.75rem] max-sm:*:max-h-[11rem]"
                  />
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
        )}

        {!!products.length && <CarouselNavigationButtons id={`${id}-products`} className="min-[1669px]:!hidden" />}
      </div>
    </div>
  );
};
